export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-usb-1f6dba276a5cf8a585a174b22047a956.svg";